export enum IAppEnum {
  Name = 'App.name',
  LogoUrl = 'App.logourl',
  DisplayColor = 'App.displaycolor',
}
